import { z } from "zod";

// `name` is optional — an unnamed token still shows "—" in the list (matches
// webhook name UX). POST /tokens/ now accepts it (2026-07-07, Alejandro).
export const createTokenSchema = z.object({
  name: z.string().trim().max(100, "Name is too long").optional(),
  sandbox: z.boolean(),
});

export type CreateTokenValues = z.infer<typeof createTokenSchema>;
